import PDFIcon from "../../Images/pdfIcon.png";

const AnnualReturn = () => {
  const documents = [
    {
      label: "View Annual Return 2025",
      fileName: "Annual-Return-2025.pdf",
    },
    // Add future annual return files here:
    // { label: "View Annual Return", fileName: "Annual-Return-2026.pdf" },
  ];

  return (
    <div className="py-80">
      <div className="container">
        <div className="row">
          <div className="col-12 mb-4">
            <div className="site-heading">
              <span className="site-title-tagline">Investor Information</span>
                <h2 className="site-title">
                  Annual <span>Return 2025</span>
                </h2>
              <div className="heading-divider"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {documents.map((doc, id) => (
            <div className="col-md-6 col-lg-4" key={id}>
              <div className="team-item p-3">
                <img src={PDFIcon} alt="pdf icon" />
                <div className="team-content">
                  <div className="team-bio">
                    <h5>Annual Return 2025</h5>
                    <a
                      className="theme-btn mt-2"
                      href={`https://essexmpl.com/Pdf/${doc.fileName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {doc.label}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnnualReturn;
